/* eslint jsx-a11y/alt-text: 0, no-useless-escape:0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setFilter } from '../../actions/material';
import _ from 'lodash';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import slugify from 'slugify';

// import cat1 from '../../assets/img/beautrium/mock/cat1.jpg';

class HeaderMegaMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: null,
        };

        this.renderSubCategories = this.renderSubCategories.bind(this);
        this.renderSubmenu = this.renderSubmenu.bind(this);
        this.renderLeftMenu = this.renderLeftMenu.bind(this);
    }

    renderSubCategories(subCategories, cat1) {
        const { currentLanguage } = this.props;
        const containerStyle = {
            display: 'flex',
            overflowX: 'auto',
            maxHeight: '500px',
        };

        const columnStyle = {
            display: 'inline-block',
            verticalAlign: 'top',
            minWidth: '200px',
            margin: '0 15px',
        };

        const balancedColumns = [];
        let currentColumn = [];
        let currentCount = 0;

        subCategories.forEach((cat2) => {
            const cat2Count = 1 + (cat2.subCategories ? cat2.subCategories.length : 0);
            if (currentCount + cat2Count > 13) {
                balancedColumns.push(currentColumn);
                currentColumn = [];
                currentCount = 0;
            }
            currentColumn.push(cat2);
            currentCount += cat2Count;
        });
        if (currentColumn.length > 0) {
            balancedColumns.push(currentColumn);
        }

        return (
            <div style={containerStyle} className="subcategories-container">
                {balancedColumns.map((column, colIndex) => (
                    <div key={colIndex} style={columnStyle}>
                        {column.map((cat2) => (
                            <ul key={`${cat1.cat1_id}_${cat2.cat2_id}`}>
                                <li>
                                    <Link to={`/shop/${slugify(cat1.category, { lower: true })}/${slugify(cat2.category, { lower: true })}`} style={{ fontWeight: '500' }}>
                                        {currentLanguage === 'th' ? cat2.category_th : cat2.category}
                                    </Link>
                                </li>
                                {cat2.subCategories &&
                                    cat2.subCategories.map((cat3) => (
                                        <li key={`${cat1.cat1_id}_${cat2.cat2_id}_${cat3.cat3_id}`} style={{ marginLeft: '15px' }}>
                                            <Link
                                                to={`/shop/${slugify(cat1.category, { lower: true })}/${slugify(cat2.category, { lower: true })}/${slugify(cat3.category, { lower: true })}`}
                                            >
                                                {currentLanguage === 'th' ? cat3.category_th : cat3.category}
                                            </Link>
                                        </li>
                                    ))}
                            </ul>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    renderSubmenu() {
        const { menu } = this.state;
        const { categories } = this.props;
        if (menu === null || !categories[menu]?.subCategories) return null;

        return this.renderSubCategories(categories[menu].subCategories, categories[menu]);
    }


    renderLeftMenu() {
        const { currentLanguage, categories } = this.props;
        if (!categories) return;
        return _.map(categories, (m, index) => {

            return (
                <li className={`${this.state.menu === index ? 'active' : ''}`} key={index} >
                    <Link to={`/shop/` + slugify(m.category, { lower: true })} onClick={() => { this.props.setFilter({ cat1_id: m.cat1_id }); }} onMouseEnter={() => this.setState({ menu: index })}>{currentLanguage === 'th' ? m.category_th : m.category}</Link>
                </li>
            );
        });
    }

    render() {
        const { visible } = this.props;
        return (
            <div className={`mega-menu-container mega-white ${!visible ? "hidden" : ""}`}>
                <div className="container h-100">
                    <div className="row menu">
                        <div className="col-xl-3 category-1">
                            <ul>
                                {this.renderLeftMenu()}
                            </ul>
                        </div>
                        <div className="col-xl-9 pl-0 sub-cat">{this.renderSubmenu()}</div>

                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        categories: state.itemCategories.categories,
    }
}
export default connect(mapStateToProps, { setFilter, getTranslate })(HeaderMegaMenu)